import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppRepository } from '@timechef/core/state';

@Directive({
  selector: '[appIfDebug]',
  standalone: false,
})
export class IfDebugDirective implements OnInit {
  private hasView = false;

  constructor(
    private appRepo: AppRepository,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit() {
    this.appRepo.debug$.subscribe((debug) => {
      if (debug && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!debug && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
